module.exports = __webpack_public_path__ + "ai.svg?22727512fe0373e1aefee8429d3ced54";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ai.svg
// module id = 987
// module chunks = 27